import { LegalShell } from "./LegalShell";

const UPDATED = "April 23, 2026";

export default function PrivacyPolicy() {
  return (
    <LegalShell title="Privacy Policy" updated={UPDATED}>
      <p>BallBoy (“we”, “us”, “our”) respects your privacy. This Privacy Policy explains how we collect, use, share
      and protect information when you use the Service.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Account information</strong>: name, email, mobile number, profile photo, role.</li>
        <li><strong>Verification information</strong>: government-issued ID photo, selfie, address, and
        verification metadata (submission/decision timestamps).</li>
        <li><strong>Activity data</strong>: bookings, chats, ratings, location pins, favorite locations.</li>
        <li><strong>Payment data</strong>: processed by PayPal; we store only confirmation tokens and payout
        status, not full card numbers.</li>
        <li><strong>Device &amp; technical data</strong>: IP address, browser, approximate geolocation, cookies,
        and usage logs.</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>To operate the Service, match Athletes and Ball Boys, enable chat and notifications.</li>
        <li>To verify identity, prevent fraud, enforce Terms and comply with law.</li>
        <li>To process payments and deliver receipts.</li>
        <li>To communicate service announcements, security alerts and (with consent) marketing.</li>
        <li>To improve and develop new features using aggregated, de-identified analytics.</li>
      </ul>

      <h2>3. How We Share Information</h2>
      <p>We share information with (a) the counterpart of your booking, limited to name, photo, trust badges,
      and location during the active session; (b) service providers acting on our behalf (PayPal for payments,
      Mailgun for email, MongoDB for storage, hosting and analytics providers), bound by contractual
      confidentiality; (c) law enforcement or regulators as required by law; (d) successors in the event of a
      merger, acquisition, or asset sale. We do not sell personal information for monetary consideration.</p>

      <h2>4. Your Choices &amp; Rights</h2>
      <p>Depending on your jurisdiction, you may have rights to access, correct, delete, export, or restrict
      processing of your personal data, and to object to certain uses. You may also withdraw consent at any
      time. To exercise these rights, email <a href="mailto:privacy@mail.ballboy.ws">privacy@mail.ballboy.ws</a>.
      <br />California residents have additional rights under the CCPA/CPRA; European users have rights under
      the GDPR including the right to lodge a complaint with a supervisory authority.</p>

      <h2>5. Data Retention</h2>
      <p>We retain account information while the account is active and for up to 7 years after deletion for
      legal, tax and dispute-resolution reasons. Verification documents are retained only as long as required
      to support the trust program and applicable law.</p>

      <h2>6. Security</h2>
      <p>We apply industry-standard safeguards (encryption in transit, access controls, principle of least
      privilege). <strong>No system is perfectly secure.</strong> You are responsible for maintaining the
      confidentiality of your credentials.</p>

      <h2>7. Children’s Privacy</h2>
      <p>The Service is not directed to children under 13 (or 16 where applicable). We do not knowingly collect
      personal information from children. Contact us to request deletion of any such data.</p>

      <h2>8. International Transfers</h2>
      <p>Your information may be processed in the United States or other jurisdictions with different data
      protection standards. By using the Service you consent to such transfers.</p>

      <h2>9. Cookies</h2>
      <p>We use cookies and similar technologies to authenticate sessions, remember preferences, and measure
      performance. You can disable cookies in your browser, but parts of the Service may not function.</p>

      <h2>10. Changes</h2>
      <p>We may update this Policy from time to time. Material changes will be announced within the Service.</p>

      <h2>11. Contact</h2>
      <p>Data Protection Officer: <a href="mailto:privacy@mail.ballboy.ws">privacy@mail.ballboy.ws</a>.</p>

      <p className="mt-8 text-xs text-muted-foreground"><em>This document is provided for operational use and does not
      constitute legal advice. Have a qualified attorney review before relying on it.</em></p>
    </LegalShell>
  );
}
